import { render, staticRenderFns } from "./ParameterSettings.vue?vue&type=template&id=04681aa0"
import script from "./ParameterSettings.vue?vue&type=script&lang=ts"
export * from "./ParameterSettings.vue?vue&type=script&lang=ts"
import style0 from "./ParameterSettings.vue?vue&type=style&index=0&id=04681aa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports